import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

// Extend dayjs with the relativeTime plugin
dayjs.extend(relativeTime);

/**
 * Format the date into a relative time (e.g., "1d ago", "2h ago", etc.)
 * @param {string} date - The ISO 8601 formatted date (e.g., '2025-02-10T06:33:34')
 * @returns {string} - The relative time string (e.g., "1d ago", "2h ago")
 */
export const formatRelativeTime = (date) => {
    return dayjs(date).fromNow();
};
